import { Item } from 'shared-types';
import { GroupedBasketItemTypes } from '../ItemListingRows';

export function separateAndGroupPackageAndNonPackageItems(
  items: any[],
  groupByItemTypeFunction: (itemArray: Item[]) => GroupedBasketItemTypes
): GroupedBasketItemTypes {
  const packageItemIds = [
    ...new Set(items.map((item) => item.packageBasketItemId).filter(Boolean)),
  ];

  const sortedItems = items.sort((a) => (a.type === 'rooms' ? -1 : 1));

  const groupedItems = sortedItems.reduce(
    (groups, item) => {
      if (packageItemIds.includes(item.id)) {
        const relatedItems = items.filter((itm) => itm.packageBasketItemId === item.id);
        groups.packageItems.push(groupByItemTypeFunction([item, ...relatedItems]));
      } else if (!item.packageBasketItemId) {
        groups.nonPackageItems.push(item);
      }
      return groups;
    },
    { packageItems: [], nonPackageItems: [] }
  );

  const groupedNonPackageItems = groupByItemTypeFunction(groupedItems.nonPackageItems);

  return { ...groupedNonPackageItems, packages: groupedItems.packageItems };
}
